export const SHOW_CART_ATC_SLIDER = 'SHOW_CART_ATC_SLIDER';

export default {
    SHOW_CART_ATC_SLIDER,
};
